import React, { useEffect, useState } from 'react'
import {  useHistoricEliteResults } from '../../services/HistoricEliteResults'
import { formatTime } from '../../services/timeHandler';
import { HistoricResultDTO } from '../../interfaces/HistoricResultDTO';
import moment from 'moment';

interface Props {
    fiscode: number | null;
}

const BiosHistoricResult = ({fiscode}:Props) => {
    const [historicResult,setHistoricResult] = useState<HistoricResultDTO[]>([]);
    const {historicResults,handleHistoricResults} = useHistoricEliteResults()
    useEffect(() => {
        handleHistoricResults(fiscode);
    },[fiscode])

    useEffect(() => {
        // if (!historicResults){
        //     setHistoricResult([]);
        //     return;
        // }
        // let hist:HistoricTimesResultRaces[] = [];
        // Object.keys(historicResults).map((key) => {
        //     let rac = historicResults[key];
        //     console.log(rac);
        //     if (rac !== undefined && rac !== null){
        //         Object.keys(rac).map((ipos) => {
        //             if (ipos === undefined){

        //             }
        //             else if (ipos == "999"){
        //                 hist.push(rac);
        //             }
        //         })
        //         console.log("aa");
        //     }
            
        // });
        // console.log(hist);
        // setHistoricResult(hist);

    },[historicResults])

    if (historicResults === null){
        return (<></>)
    }
    const formatRaceName = (raceName:string):string => {
      return raceName.replace("Ford Smart Energy Cup","FSEC").replace("Smart Energy Cup","SEC").replace("Smart Energy","SEC").replace("Volkswagen","VW");
    }


  return (
    <>{historicResults.map((obj,index) => {
        if (obj.Status === "ENT" || obj.Status === "START"){
          return <></>
        }
        return (<tr className="bios-historic-time-row" data-key={(obj.RaceId +  obj.ClassId + index).toString(4)} key={obj.RaceId + "v" + obj.ClassId + "v" + index}>
        <td className="bios-historic-time-row-position">{formatRaceName(obj.RaceName) + ` (${obj.RacePlace})`} <br/> Klubb:<b>{obj.Team}</b></td>
        <td className="bios-historic-time-row-date">
        {moment( obj.RaceDate).format("YY-MM-DD")}
        </td>
        <td className="bios-historic-time-row-rank" >
        {999 in obj.Times && obj.Status === "OK" ? obj.Times[999].RankClass : <>&nbsp;</>}
        </td>
        <td className="bios-historic-time-row-time">
          {999 in obj.Times && obj.Status === "OK" ? formatTime(obj.Times[999].RunTime, obj.TimeFormat) : <>{obj.Status}</>}
        </td>
        <td className="bios-historic-time-row-diff">
          {999 in obj.Times && obj.Status === "OK"  ? "+" + formatTime(obj.Times[999].DiffClass, obj.TimeFormat) : <>&nbsp;</>}
        </td>
      </tr>)
    })}</>
  )
}

export default BiosHistoricResult